import { setCookie } from '@/utilities/cookies';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    locale: 'tr',
    pagesGroup: null,
    globalLoading: false
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        setLocale: (state, action) => {
            state.locale = action.payload;
            setCookie('locale', action.payload, 30);
        },
        setPagesGroup: (state, action) => {  
            state.pagesGroup = action.payload;
        },
        setGlobalLoading: (state, action) => {
            state.globalLoading = action.payload;
        }
    },
});

export const { setLocale, setPagesGroup } = pageSlice.actions;
export default pageSlice.reducer;